import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";
import { addGarmentPack, updateGarmentPack } from "../../../services/GarmentPack/GarmentPack";

const GarmentPackCreateModal = ({
  garmentPackCreateModalVisible,
  setGarmentPackCreateModalVisible,
  sendDataToGarmentPackCreateModal,
  brandId,
  selectedItemValue,
}) => {
  const [modalText, setModalText] = useState('');
  const [statusValue, setStatusValue] = useState('');
  const [statusError, setStatusError] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [garmentPackValue, setGarmentPackValue] = useState('');
  const [garmentPackError, setGarmentPackError] = useState('');
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const statusItems = [
    {
      name: 'Active',
      value: true,
    },
    {
      name: 'DeActive',
      value: false,
    },
  ];

  useEffect(() => {
    if (selectedItemValue !== null) {
      setGarmentPackValue(selectedItemValue?.name || '');
      setStatusValue(selectedItemValue?.status || false);
    }
  }, [selectedItemValue]);

 
  const handleConfirmPickup = () => {
    // Reset all previous errors
    setGarmentPackError('');
    setStatusError('');

    let isValid = true;
    if (!garmentPackValue) {
      setGarmentPackError('Packing Type Name is required');
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedItemValue === null) {
          const data = {
            brandId: brandId,
            name: garmentPackValue,
            status: true,
          };
          addGarmentPack(brandId, data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                  }
                  setGarmentPackValue('');
                  setStatusValue('');
                  setGarmentPackError('');
                  setStatusError('');
                  setIsSubmitButtonPressed(false);
                  sendDataToGarmentPackCreateModal({
                    success: true,
                  });
                  setGarmentPackCreateModalVisible(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        } else {
          const updateData = {
            ...selectedItemValue,
            brandId: brandId,
            name: garmentPackValue,
            status: statusValue,
          };
          updateGarmentPack(brandId, updateData)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                  }

                  setGarmentPackValue('');

                  setStatusValue('');

                  setGarmentPackError('');

                  setStatusError('');
                  setIsSubmitButtonPressed(false);
                  sendDataToGarmentPackCreateModal({
                    success: true,
                  });
                  setGarmentPackCreateModalVisible(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        }
      }
    }
  };

  const handleModalClose = () => {
    setGarmentPackValue('');
    setStatusValue('');

    setGarmentPackError('');
    setStatusError('');
    setIsSubmitButtonPressed(false);
    setGarmentPackCreateModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={garmentPackCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!garmentPackCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
              Pack {selectedItemValue === null ? 'Create' : 'Edit'}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="mx-4 mt-4">
              <FloatLabel>
                <InputText
                  id="garmentPackValue"
                  value={garmentPackValue}
                  onChange={(e) => setGarmentPackValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Packing Type"
                />
                <label
                  htmlFor="garmentPackValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Packing Type <span style={{ color: "red" }}>*</span>
                </label>
                {garmentPackError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {garmentPackError}
                  </p>
                )}
              </FloatLabel>
            </div>
             

            {selectedItemValue !== null && (
            <div className="mx-4 mt-4  ">
              <FloatLabel>
                <Dropdown
                  id="statusValue"
                  value={statusValue}
                  onChange={(e) => setStatusValue(e.value)}
                  options={statusItems}
                  optionLabel="name"
                  placeholder="Status"
                  className="w-full border-round-xl  text-2xl text-xl shadow-2"
                />
                {statusError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {statusError}
                  </p>
                )}
                <label
                  htmlFor="statusValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Status 
                  <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>
            </div>
            )}
             
            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
       <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default GarmentPackCreateModal;
